/**
 * Applies the filters in the global state to the current list. For example,
 * applying `status: ["active"]` to a list of residents.
 *
 * @param {Object} filters taken from `state.global.filters[filterId]`
 * @param {Array} list collection such as residents or carers
 */
export function applyFiltersToList(filters, list) {
  return list.filter((listItem) => {
    let result = true

    for (const key in filters) {
      const values = filters[key]
      if (!values || !values.length) {
        continue
      }
      if (!values.includes(listItem[key])) {
        result = false
      }
    }

    return result
  })
}
